import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../services/api';

const name = 'deleteFeedbackType';
const initialState = createInitialState();

function createInitialState() {
    return {
        done: false,
        error: false,
        spinner: false,
        deleteFeedbackType: null,
    };
}

export const deleteFeedbackType = createAsyncThunk('deleteFeedbackType', async (id, { rejectWithValue }) => {
    try {
        const response = await api.delete(`/super/api/feedback/type/delete/${id}`);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

const deleteFeedbackTypeSlice = createSlice({
    name: name,
    initialState,
    reducers: {
        resetDeleteFeedbackType: state => {
            state.done = false;
            state.error = false;
            state.spinner = false;
            state.deleteFeedbackType = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(deleteFeedbackType.pending, state => {
                state.spinner = true;
                state.error = false;
            })
            .addCase(deleteFeedbackType.fulfilled, (state, action) => {
                state.done = true;
                state.spinner = false;
                state.error = false;
                state.deleteFeedbackType = action.payload;
            })
            .addCase(deleteFeedbackType.rejected, (state, action) => {
                state.done = false;
                state.spinner = false;
                state.error = action.payload;
            });
    },
});

export const { resetDeleteFeedbackType } = deleteFeedbackTypeSlice.actions;
export const deleteFeedbackTypeReducer = deleteFeedbackTypeSlice.reducer;
